import { VJSBridge } from './../libs/VJSBridge';
/*
 * @Description: 全局注册属性
 * @Author: erickuang
 * @Date: 2021-01-21 19:36:43
 * @LastEditor: erickuang
 * @LastEditTime: 2021-08-16 20:40:39
 */
import { VueConstructor } from 'vue/types';
import { getProConsole } from '@tencent/v-common-utils';

export interface VueGlobal {
  isDebug: boolean;
  proConsole: any;
}

export const global: VueGlobal = {
  isDebug: process.env.NODE_ENV === 'development',
  proConsole: getProConsole(),
};

export default {
  install(Vue: VueConstructor) {
    Vue.prototype._global = global;
    global.proConsole.info(`Current ENV: ${process.env.NODE_ENV}`);

    // 添加<template></template> optional chaining workaround
    Vue.mixin({
      data() {
        return {
          VJSBridge: VJSBridge.getVJSBridge(),
        };
      },
      methods: {
        _optional(fn: () => any, placeholder = '') {
          try {
            if (typeof fn === 'function') {
              return fn();
            }
          } catch (error) {
            console.log('Global script optional chaining error: ', error);
            return placeholder;
          }
        },
      },
    });
  },
};
